import React from 'react'
import Icon from 'components/ui/icon'
import styles from './index.module.css'

const MAX_DISPLAYED_BADGE_COUNT = 99

interface NotificationBellProps {
  badge: number
  onClick: () => void
}

const NotificationBell = ({ badge, onClick }: NotificationBellProps) => {
  const displayedCount =
    badge > MAX_DISPLAYED_BADGE_COUNT ? `${MAX_DISPLAYED_BADGE_COUNT}+` : badge

  return (
    <button
      className={styles.notificationBell}
      type="button"
      onClick={onClick}
      aria-label={
        badge > 0 ? `Notifications, ${displayedCount} unread` : 'Notifications'
      }
    >
      <Icon type="notification" width="24" height="24" />
      {badge > 0 ? (
        <div className={styles.notificationBellBadge} aria-hidden="true">
          {displayedCount}
        </div>
      ) : null}
    </button>
  )
}

export default NotificationBell
